// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2a4DT","modalForm":"UpgradeEpcsModal_modalForm__1PZw9","modalFooter":"UpgradeEpcsModal_modalFooter__3TvBm"};